import { FlowConditionContactDetails } from './types.flow';
import { DescribeOptions } from '~/scenes/Automation/Flows/types.flow';
import { DescribeNodeType } from '~/scenes/Automation/Flows/Actions/util/descriptionStandards';

import describeMultipleFields from '../util/describeMultipleFields';

const describeContactDetailsCondition = (
  condition: FlowConditionContactDetails,
  describeOptions: DescribeOptions,
): DescribeNodeType => {
  const { fields, allShouldBeTrue } = condition;

  return describeMultipleFields(fields, allShouldBeTrue, describeOptions);
};

export default describeContactDetailsCondition;
